function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { stateGo } from 'redux-ui-router';
import i18n from 'invision-core/src/components/i18n/i18n';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
import CustomerLocaleKeys from '../../../../../../locales/keys';
import { SERVICE_USAGE_DETAILS_STATE_NAME } from '../../../../servicesAndUsage/usageDetails/usage.details.config';
import { SERVICES_AND_SHARED_ENTITLEMENTS, SERVICES_AND_SHARED_ENTITLEMENTS_TAB } from '../../../../servicesAndUsage/services.and.usage.config';
import { setSelectedSharedEntitlementIndex } from '../../../../../../reducers/actions/shared.entitlements.actions';
import { ENTITLEMENT_SHARE_STATUS } from '../../../../../../customercare.constants';
import { updateDashboardEntitlementShareStatus } from '../../../../../../reducers/actions/customer.convergent.biller.actions';
import { CurrentCustomerIdSelector } from '../../../../../../reducers/selectors/customer.selectors';
import { NUMBER_OF_ENTITLEMENTS_TO_DISPLAY } from '../services.and.offers.contants';
import { hasAccess } from 'invision-core/src/components/security/permission.service';
import { ENTITLEMENT_BALANCE_UPDATE_ACCESS } from '../../../../../../security.attributes';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { USAGE_DETAILS_NON_TELCO_SERVICES_REDIRECT } from '../../../../../../reactRoutes';
var EntitlementsGridController = /*#__PURE__*/function () {
  function EntitlementsGridController($ngRedux, $timeout, uiNotificationService) {
    _classCallCheck(this, EntitlementsGridController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      CustomerLocaleKeys: CustomerLocaleKeys,
      ENTITLEMENT_SHARE_STATUS: ENTITLEMENT_SHARE_STATUS,
      handleMoreOptionsSelected: this.handleMoreOptionsSelected.bind(this),
      handleOnClick: this.handleOnClick.bind(this),
      uiNotificationService: uiNotificationService,
      updateEntitlementShareStatus: this.updateEntitlementShareStatus.bind(this)
    });
  }
  return _createClass(EntitlementsGridController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var controllerActions = {
        setSelectedSharedEntitlementIndex: setSelectedSharedEntitlementIndex,
        stateGo: stateGo,
        updateDashboardEntitlementShareStatus: updateDashboardEntitlementShareStatus
      };
      var mapStateToProps = function mapStateToProps(store) {
        return {
          currentCustomerId: CurrentCustomerIdSelector(store),
          userSecurityAttributes: UserSecurityAttributesSelector(store)
        };
      };
      this.moreMenuItems = [{
        id: CustomerLocaleKeys.CUSTOMER_DASHBOARD.SERVICES_WIDGET.EDIT_ENTITLEMENT_MODAL.TITLE,
        title: i18n.translate(CustomerLocaleKeys.CUSTOMER_DASHBOARD.SERVICES_WIDGET.EDIT_ENTITLEMENT_MODAL.TITLE)
      }];
      this.disconnectRedux = this.$ngRedux.connect(mapStateToProps, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.editEntitlementModalConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.handleEditEntitlementModalConfig = event.api;
        }
      };
      this.showMoreItems = convertStringToNumber(this.entitlementsCount) > NUMBER_OF_ENTITLEMENTS_TO_DISPLAY;
    }
  }, {
    key: "handleOnClick",
    value: function handleOnClick(entitlementIndex, entitlementId, balanceIterationId) {
      if (this.isShared) {
        this.actions.setSelectedSharedEntitlementIndex(entitlementIndex || 0);
        this.actions.stateGo(SERVICES_AND_SHARED_ENTITLEMENTS, {
          tabName: SERVICES_AND_SHARED_ENTITLEMENTS_TAB.SHARED_ENTITLEMENTS
        });
      } else {
        if (this.isNonTelcoUsageServicePageEnabled) {
          this.actions.stateGo(USAGE_DETAILS_NON_TELCO_SERVICES_REDIRECT, {
            customerId: this.state.currentCustomerId,
            serviceIdentifierValue: this.serviceIdentifier.Value
          });
        } else {
          this.actions.stateGo(SERVICE_USAGE_DETAILS_STATE_NAME, {
            entitlementId: entitlementId,
            entitlementIndex: entitlementIndex,
            balanceIterationId: balanceIterationId,
            serviceIdentifierValue: this.serviceIdentifier.Value,
            serviceIdentifierName: this.serviceIdentifier.ServiceIdentifierName,
            serviceAttributeId: this.serviceIdentifier.ServiceAttributeId,
            serviceIdentifierFriendlyName: this.serviceIdentifier.FriendlyName
          });
        }
      }
    }
  }, {
    key: "hasEntitlementEditAccess",
    value: function hasEntitlementEditAccess() {
      return hasAccess(this.state.userSecurityAttributes, ENTITLEMENT_BALANCE_UPDATE_ACCESS);
    }
  }, {
    key: "updateEntitlementShareStatus",
    value: function updateEntitlementShareStatus(entitlement) {
      var _this2 = this;
      var newStatus = entitlement.SharingStatus === ENTITLEMENT_SHARE_STATUS.ENABLED ? ENTITLEMENT_SHARE_STATUS.DISABLED : ENTITLEMENT_SHARE_STATUS.ENABLED;
      this.actions.updateDashboardEntitlementShareStatus(this.state.currentCustomerId, entitlement.EntitlementIdentifier, newStatus).then(function () {
        _this2.uiNotificationService.transientSuccess(i18n.translate(newStatus === ENTITLEMENT_SHARE_STATUS.ENABLED ? CustomerLocaleKeys.SHARING_ACTIONS.ENABLE_SUCCESS : CustomerLocaleKeys.SHARING_ACTIONS.DISABLE_SUCCESS));
        _this2.refreshServiceDetails && _this2.refreshServiceDetails();
      }).catch(function (error) {
        _this2.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "handleMoreOptionsSelected",
    value: function handleMoreOptionsSelected(_ref) {
      var item = _ref.item;
      switch (item.id) {
        case CustomerLocaleKeys.CUSTOMER_DASHBOARD.SERVICES_WIDGET.EDIT_ENTITLEMENT_MODAL.TITLE:
          this.openEditEntitlementModal();
          break;
        default:
      }
    }
  }, {
    key: "openEditEntitlementModal",
    value: function openEditEntitlementModal() {
      var _this3 = this;
      this.openEditEntitlementModalOpened = true;
      this.$timeout(function () {
        _this3.handleEditEntitlementModalConfig.open();
      });
    }
  }, {
    key: "closeEditEntitlementModal",
    value: function closeEditEntitlementModal() {
      this.openEditEntitlementModalOpened = false;
      this.handleEditEntitlementModalConfig.close();
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  bindings: {
    currencyCode: '<',
    entitlements: '<',
    entitlementsCount: '<',
    isNonTelcoUsageServicePageEnabled: '<',
    isShared: '<?',
    refreshServiceDetails: '&?',
    serviceIdentifier: '<'
  },
  controller: EntitlementsGridController,
  template: require('./entitlements.grid.template.html')
};